<div class="modal locationPermission d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered m-auto" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
         <h1 class="text-left">{{welcomeMapTranslation['title']}}</h1>
         <p class="font-weight-normal text-left">{{welcomeMapTranslation['content']}}</p>
         <button (click)="welcomeToMapBox.emit(false)" class="continue-btn font-weight-bold fs-3"><img src="../../../assets/check.svg" alt="">{{welcomeMapTranslation['btnContent']}}</button>
        </div>
      </div>
    </div>
</div>
